import React from 'react'

import { ActionAdmin } from '@/pages/ActionAdmin'
import { Admins, CreateAdmin, UpdateAdmin } from '@/pages/Admin'
import { AnnouncementImport, Announcements, CreateAnnouncement, UpdateAnnouncement } from '@/pages/Announcements'
import { Attendance } from '@/pages/Attendance'
import { AttendanceEmployeeByDay } from '@/pages/AttendanceEmployee'
import { AttendanceLogs } from '@/pages/AttendanceLogs'
import ExportHistory from '@/pages/AttendanceLogs/ExportHistory/ExportHistory'
import { Clients } from '@/pages/Client'
import DeviceDetail from '@/pages/Client/DeviceDetail'
import DeviceError from '@/pages/Client/DeviceError/DeviceError'
import ClientDeviceByDay from '@/pages/ClientDevice'
import { ConfigTimeWork } from '@/pages/ConfigTimeWork'
import CreateCustomer from '@/pages/Customer/Create/Create'
import Customers from '@/pages/Customer/Customer'
import CustomerDetail from '@/pages/Customer/CustomerDetail'
import ImportCustomer from '@/pages/Customer/Import/Import'
import UpdateCustomer from '@/pages/Customer/UpdateCustomer/UpdateCustomer'
import CreateDetergentHistory from '@/pages/DetergentHistories/Create/Create'
import DetergentHistories from '@/pages/DetergentHistories/DetergentHistory'
import UpdateDetergentHistory from '@/pages/DetergentHistories/Update/Update'
import CreateDetergent from '@/pages/Detergents/Create/Create'
import Detergents from '@/pages/Detergents/Detergent'
import ImportDetergent from '@/pages/Detergents/Import/Import'
import UpdateDetergent from '@/pages/Detergents/Update/Update'
import { CreateEmployee, Employees, EmployeesImport, UpdateEmployee } from '@/pages/Employees'
import { Home } from '@/pages/Home'
import { CreateIdCard, IdCards, IdCardsImport } from '@/pages/IdCards'
import { Incident } from '@/pages/Incident'
import { CreateLanguage, Languages, UpdateLanguage } from '@/pages/Languages'
import { Login } from '@/pages/Login'
import CreateMachine from '@/pages/Machine/Create/Create'
import ImportMachine from '@/pages/Machine/Import/Import'
import ImportTankToMachine from '@/pages/Machine/Import/ImportTank'
import Machines from '@/pages/Machine/Machine'
import UpdateMachine from '@/pages/Machine/Update/Update'
import CreateMachinePart from '@/pages/MachineParts/Create/Create'
import MachineParts from '@/pages/MachineParts/MachinePart'
import UpdateMachinePart from '@/pages/MachineParts/Update/Update'
import Notifications from '@/pages/Notifications/Notification'
import CreateOperator from '@/pages/Operators/Create/Create'
import ImportOperator from '@/pages/Operators/Import/Import'
import Operators from '@/pages/Operators/Operator'
import UpdateOperator from '@/pages/Operators/Update/Update'
import CreateTank from '@/pages/Tank/Create/Create'
import ImportTank from '@/pages/Tank/Import/Import'
import Tanks from '@/pages/Tank/Tank'
import UpdateTank from '@/pages/Tank/Update/Update'
import CreateTankHistory from '@/pages/TankHistory/Create/Create'
import TankHistories from '@/pages/TankHistory/TankHistory'
import { CreateTerminal, Terminals, UpdateTerminal } from '@/pages/Terminals'
import { CreateUniform, Uniforms, UniformsImport, UpdateUniform } from '@/pages/Uniforms'
import WashingCountByDay from '@/pages/WashingCount'
import WashingHistory from '@/pages/WashingHistory'
import CreateWashingMachinePart from '@/pages/WashingMachinePart/Create/Create'
import ImportWashingMachinePart from '@/pages/WashingMachinePart/Import/Import'
import UpdateWashingMachinePart from '@/pages/WashingMachinePart/Update/Update'
import WashingMachineParts from '@/pages/WashingMachinePart/WashingMachinePart'
import CreateWashingMethod from '@/pages/WashMethods/Create/Create'
import ImportWashingMethod from '@/pages/WashMethods/Import/Import'
import UpdateWashingMethod from '@/pages/WashMethods/Update/Update'
import WashingMethods from '@/pages/WashMethods/WashingMethod'
import WashingMethodDetail from '@/pages/WashMethods/WashingMethodDetail'
import { UserPermission } from '@/types/apis/admins/GetMeResponse'

const EMPLOYEE_PATH = '/employees'
const ID_CARD_PATH = '/id-cards'
const UNIFORM_PATH = '/uniforms'
const TERMINAL_PATH = '/terminals'
const ANNOUNCEMENT_PATH = '/announcements'
const LANGUAGES_PATH = '/languages'
const LOGIN_PATH = '/login'
const ADMIN_PATH = '/users'
const ATTENDANCE_PATH = '/attendance-logs'
const CLIENT_DEVICE_PATH = '/client-device'
const ATTENDANCE_EMPLOYEE_PATH = '/attendance-employee'
const ATTENDANCE = '/attendance'
const CONFIG_PATH = '/configs'
const CLIENT_PATH = '/devices'
const INCIDENT_PATH = '/incident'
const DEVICE_ERROR_PATH = '/device-errors'
const ACTION_PATH = '/actions'
const LAUNDRY_PATH = '/laundry'
const NOTIFICATION_PATH = '/notifications'

export type Route = {
  path: string
  component: React.FC
  isPrivate: boolean
  permission?: UserPermission
}

const routes: Record<string, Route> = {
  login: {
    path: LOGIN_PATH,
    component: Login,
    isPrivate: false,
  },
  configs: {
    path: CONFIG_PATH,
    component: ConfigTimeWork,
    isPrivate: true,
    permission: 'admin/view',
  },
  actionAdmin: {
    path: ACTION_PATH,
    component: ActionAdmin,
    isPrivate: true,
    permission: 'admin/view',
  },

  clients: {
    path: CLIENT_PATH,
    component: Clients,
    isPrivate: true,
    permission: 'admin/view',
  },
  deviceError: {
    path: DEVICE_ERROR_PATH,
    component: DeviceError,
    isPrivate: true,
    permission: 'admin/view',
  },
  clientDeviceDetail: {
    path: `${CLIENT_PATH}/:id`,
    component: DeviceDetail,
    isPrivate: true,
    permission: 'admin/view',
  },
  incident: {
    path: INCIDENT_PATH,
    component: Incident,
    isPrivate: true,
    permission: 'admin/view',
  },
  admins: {
    path: ADMIN_PATH,
    component: Admins,
    isPrivate: true,
    permission: 'admin/view',
  },
  createAdmin: {
    path: `${ADMIN_PATH}/create`,
    component: CreateAdmin,
    isPrivate: true,
  },
  attendanceLogs: {
    path: `${ATTENDANCE_PATH}`,
    component: AttendanceLogs,
    isPrivate: true,
  },
  clientDeviceByDay: {
    path: CLIENT_DEVICE_PATH,
    component: ClientDeviceByDay,
    isPrivate: true,
  },
  attendanceEmployeeByDay: {
    path: ATTENDANCE_EMPLOYEE_PATH,
    component: AttendanceEmployeeByDay,
    isPrivate: true,
  },
  attendance: {
    path: `${ATTENDANCE}`,
    component: Attendance,
    isPrivate: true,
  },

  attendanceLogsExportHistory: {
    path: `${ATTENDANCE_PATH}/export-history`,
    component: ExportHistory,
    isPrivate: true,
  },
  updateAdmin: {
    path: `${ADMIN_PATH}/:id`,
    component: UpdateAdmin,
    isPrivate: true,
    permission: 'admin/update',
  },
  employees: {
    path: EMPLOYEE_PATH,
    component: Employees,
    isPrivate: true,
  },
  updateEmployee: {
    path: `${EMPLOYEE_PATH}/:id`,
    component: UpdateEmployee,
    isPrivate: true,
    permission: 'employee/update',
  },
  createEmployee: {
    path: `${EMPLOYEE_PATH}/create`,
    component: CreateEmployee,
    isPrivate: true,
    permission: 'employee/create',
  },
  employeesImport: {
    path: `${EMPLOYEE_PATH}/import`,
    component: EmployeesImport,
    isPrivate: true,
  },
  home: {
    path: '/',
    component: Home,
    isPrivate: true,
  },
  idCards: {
    path: ID_CARD_PATH,
    component: IdCards,
    isPrivate: true,
  },
  createIdCard: {
    path: `${ID_CARD_PATH}/create`,
    component: CreateIdCard,
    isPrivate: true,
  },
  announcements: {
    path: ANNOUNCEMENT_PATH,
    component: Announcements,
    isPrivate: true,
  },
  updateAnnouncement: {
    path: `${ANNOUNCEMENT_PATH}/:id`,
    component: UpdateAnnouncement,
    isPrivate: true,
    permission: 'annoucement/update',
  },
  createAnnouncement: {
    path: `${ANNOUNCEMENT_PATH}/create`,
    component: CreateAnnouncement,
    isPrivate: true,
    permission: 'annoucement/create',
  },
  announcementsImport: {
    path: `${ANNOUNCEMENT_PATH}/import`,
    component: AnnouncementImport,
    isPrivate: true,
  },
  idCardsImport: {
    path: `${ID_CARD_PATH}/import`,
    component: IdCardsImport,
    isPrivate: true,
  },
  languages: {
    path: LANGUAGES_PATH,
    component: Languages,
    isPrivate: true,
  },
  updateLanguage: {
    path: `${LANGUAGES_PATH}/:id`,
    component: UpdateLanguage,
    isPrivate: true,
    permission: 'language/update',
  },
  createLanguage: {
    path: `${LANGUAGES_PATH}/create`,
    component: CreateLanguage,
    isPrivate: true,
    permission: 'language/create',
  },
  terminals: {
    path: TERMINAL_PATH,
    component: Terminals,
    isPrivate: true,
  },
  createTerminal: {
    path: `${TERMINAL_PATH}/create`,
    component: CreateTerminal,
    isPrivate: true,
  },
  updateTerminal: {
    path: `${TERMINAL_PATH}/:id`,
    component: UpdateTerminal,
    isPrivate: true,
  },
  uniforms: {
    path: UNIFORM_PATH,
    component: Uniforms,
    isPrivate: true,
  },
  createUniform: {
    path: `${UNIFORM_PATH}/create`,
    component: CreateUniform,
    isPrivate: true,
  },
  uniformsImport: {
    path: `${UNIFORM_PATH}/import`,
    component: UniformsImport,
    isPrivate: true,
  },
  updateUniform: {
    path: `${UNIFORM_PATH}/:id`,
    component: UpdateUniform,
    isPrivate: true,
  },
  laundry: {
    path: LAUNDRY_PATH,
    component: Customers,
    isPrivate: true,
  },
  operators: {
    path: `${LAUNDRY_PATH}/operators`,
    component: Operators,
    isPrivate: true,
  },
  createOperator: {
    path: `${LAUNDRY_PATH}/operators/create`,
    component: CreateOperator,
    isPrivate: true,
  },
  updateOperator: {
    path: `${LAUNDRY_PATH}/operators/:id`,
    component: UpdateOperator,
    isPrivate: true,
  },
  importOperators: {
    path: `${LAUNDRY_PATH}/operator/import`,
    component: ImportOperator,
    isPrivate: true,
  },
  customers: {
    path: '/customers',
    component: Customers,
    isPrivate: true,
  },
  customerDetail: {
    path: '/customers/detail/:id',
    component: CustomerDetail,
    isPrivate: true,
  },
  createCustomer: {
    path: '/customers/create',
    component: CreateCustomer,
    isPrivate: true,
  },
  updateCustomer: {
    path: '/customers/:id',
    component: UpdateCustomer,
    isPrivate: true,
  },
  customersImport: {
    path: '/customer/import',
    component: ImportCustomer,
    isPrivate: true,
  },
  washingMachinePart: {
    path: '/washing-machine-part',
    component: WashingMachineParts,
    isPrivate: true,
  },
  createWashingMachinePart: {
    path: '/washing-machine-part/create',
    component: CreateWashingMachinePart,
    isPrivate: true,
  },
  updateWashingMachinePart: {
    path: '/washing-machine-part/:id/update',
    component: UpdateWashingMachinePart,
    isPrivate: true,
  },
  importWashingMachinePart: {
    path: '/washing-machine-part/import',
    component: ImportWashingMachinePart,
    isPrivate: true,
  },
  machines: {
    path: '/machines',
    component: Machines,
    isPrivate: true,
  },
  createMachine: {
    path: '/machines/create',
    component: CreateMachine,
    isPrivate: true,
  },
  updateMachine: {
    path: '/machines/:id',
    component: UpdateMachine,
    isPrivate: true,
  },
  importMachines: {
    path: '/machine/import',
    component: ImportMachine,
    isPrivate: true,
  },
  importTankToMachines: {
    path: '/machine/import-tank-to-machines',
    component: ImportTankToMachine,
    isPrivate: true,
  },
  machineParts: {
    path: '/machines/:id/machine-part',
    component: MachineParts,
    isPrivate: true,
  },
  createMachineParts: {
    path: '/machines/:id/machine-part/create',
    component: CreateMachinePart,
    isPrivate: true,
  },
  updateMachineParts: {
    path: '/machine/:machineId/machine-part/:id/update',
    component: UpdateMachinePart,
    isPrivate: true,
  },
  detergents: {
    path: '/detergents',
    component: Detergents,
    isPrivate: true,
  },
  createDetergent: {
    path: '/detergents/create',
    component: CreateDetergent,
    isPrivate: true,
  },
  updateDetergent: {
    path: '/detergents/:id',
    component: UpdateDetergent,
    isPrivate: true,
  },
  detergentsImport: {
    path: '/detergent/import',
    component: ImportDetergent,
    isPrivate: true,
  },
  detergentHistories: {
    path: '/detergents/:id/detergent-histories',
    component: DetergentHistories,
    isPrivate: true,
  },
  createDetergentHistory: {
    path: '/detergents/:id/detergent-histories/create',
    component: CreateDetergentHistory,
    isPrivate: true,
  },
  updateDetergentHistory: {
    path: '/detergents/:detergentId/detergent-histories/:id/update',
    component: UpdateDetergentHistory,
    isPrivate: true,
  },
  tanks: {
    path: '/tanks',
    component: Tanks,
    isPrivate: true,
  },
  createTank: {
    path: '/tanks/create',
    component: CreateTank,
    isPrivate: true,
  },
  updateTank: {
    path: '/tanks/:id',
    component: UpdateTank,
    isPrivate: true,
  },
  tanksImport: {
    path: '/tanks/import',
    component: ImportTank,
    isPrivate: true,
  },
  tankHistories: {
    path: '/tanks/:id/tank-histories',
    component: TankHistories,
    isPrivate: true,
  },
  createTankHistory: {
    path: '/tanks/:id/tank-histories/create',
    component: CreateTankHistory,
    isPrivate: true,
  },
  washingMethods: {
    path: '/washing-methods',
    component: WashingMethods,
    isPrivate: true,
  },
  washingMethodDetail: {
    path: '/washing-methods/:id',
    component: WashingMethodDetail,
    isPrivate: true,
  },
  createWashingMethod: {
    path: '/washing-methods/create',
    component: CreateWashingMethod,
    isPrivate: true,
  },
  updateWashingMethod: {
    path: '/washing-methods/:id/update',
    component: UpdateWashingMethod,
    isPrivate: true,
  },
  importWashingMethods: {
    path: '/washing-methods/import',
    component: ImportWashingMethod,
    isPrivate: true,
  },
  washingCountByDay: {
    path: '/washing-count',
    component: WashingCountByDay,
    isPrivate: true,
  },
  notifications: {
    path: `${NOTIFICATION_PATH}`,
    component: Notifications,
    isPrivate: true,
  },
  washingHistory: {
    path: '/washing-history',
    component: WashingHistory,
    isPrivate: true,
  },
}

export default routes
